"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const InputElement = (0, react_1.forwardRef)(({ id, className, type, style, value, defaultValue, placeholder, isEnterPrevent = false, textarea = false, isDisable = false, isNumber = false, min, max, tabIndex, isAutoHeight = false, maxNumLen, textRef, onSubmit, onChange, onKeyDown, onBackspace, onFocus, onBlur, }, ref) => {
    const [height, setHeight] = (0, react_1.useState)('auto');
    const [content, setContent] = (0, react_1.useState)(value || defaultValue || '');
    const textareaRef = (0, react_1.useRef)(null);
    const getCurrentTextarea = () => {
        // Use textRef if provided, otherwise fallback to textareaRef
        return textRef?.current || textareaRef.current;
    };
    const autoGrow = element => {
        element.style.height = 'auto';
        element.style.height = `${element.scrollHeight}px`;
    };
    (0, react_1.useEffect)(() => {
        if (textarea) {
            autoGrow(getCurrentTextarea());
        }
    }, [content, textarea]);
    const onKeyUpdateInput = (e) => {
        e.stopPropagation();
        if (isEnterPrevent) {
            if ((e.key === 'Space' || e.key === 'Enter' || e.key === 'NumpadEnter') &&
                !e.shiftKey) {
                e.preventDefault();
                onSubmit && onSubmit();
                return;
            }
        }
        if (onKeyDown) {
            // @ts-ignore
            onKeyDown(e.target?.value);
        }
        // SMS 생성에서 #{...} 삭제 (SendSMSRegist.tsx)
        if (e.key === 'Backspace' && onBackspace) {
            const textarea = e.target;
            const cursorPosition = textarea.selectionStart;
            const regex = /#{[^}]+}/g;
            let match;
            let hasTargetMatch = false;
            while ((match = regex.exec(textarea.value)) !== null) {
                const startIdx = match.index;
                const endIdx = startIdx + match[0].length;
                if (cursorPosition > startIdx && cursorPosition <= endIdx) {
                    hasTargetMatch = true;
                    break;
                }
            }
            if (hasTargetMatch) {
                e.preventDefault();
                onBackspace();
            }
        }
    };
    const updateInputValue = (e) => {
        const { value } = e.target;
        if (isNumber || type === 'number') {
            if (value &&
                (!/^-?\d+$/.test(value) ||
                    (maxNumLen && value.replace('-', '').length > maxNumLen))) {
                e.preventDefault();
                // 음수 기호를 유지하면서 숫자만 남기고 최대 maxNumLen 자리까지만 유지
                e.target.value = value
                    .replace(/[^-\d]/g, '')
                    .slice(0, value.startsWith('-') ? maxNumLen + 1 : maxNumLen);
                return;
            }
        }
        setContent(value);
        onChange && onChange(value);
    };
    return textarea ? (react_1.default.createElement("textarea", { ref: textRef ? textRef : textareaRef, id: id, className: className, value: value, defaultValue: defaultValue, placeholder: placeholder, style: { ...style, ...(isAutoHeight ? { height } : {}) }, disabled: isDisable, spellCheck: false, onKeyDown: onKeyUpdateInput, onChange: updateInputValue, onFocus: onFocus, onBlur: onBlur, readOnly: isDisable, maxLength: max ? Number(max) : undefined })) : (react_1.default.createElement("input", { ref: ref, id: id, className: className, type: type, value: value, defaultValue: defaultValue, placeholder: placeholder, style: style, disabled: isDisable, spellCheck: false, onKeyDown: onKeyUpdateInput, onChange: updateInputValue, onFocus: onFocus, onBlur: onBlur, min: min, tabIndex: tabIndex, readOnly: isDisable, max: type === 'date' ? '9999-12-31' : undefined, maxLength: max ? Number(max) : undefined }));
});
exports.default = InputElement;
